import { Icon, IconProps } from "./Icon";

export function IconMap(props: IconProps) {
  return (
    <Icon {...props}>
      <path d="M15.83.08 8.17 3.19 1.83.62A1.13 1.13 0 0 0 .58.67 1.36 1.36 0 0 0 0 1.85v18A1.28 1.28 0 0 0 .83 21l7.34 3 7.66-3.11 6.34 2.57a1.33 1.33 0 0 0 1.25-.13 1.31 1.31 0 0 0 .58-1.09V3.39ZM23 22.24a.32.32 0 0 1-.14.26.33.33 0 0 1-.31 0l-6.72-2.72-7.15 2.9V6h-1v16.72L1.2 20.09a.33.33 0 0 1-.2-.21v-18a.39.39 0 0 1 .14-.35.35.35 0 0 1 .19-.06s.08 0 .12.11l6.72 2.69 7.25-2.94v16.75h1V1.4L23 4.07Z" />
    </Icon>
  );
}
